import { useCollection } from '_/contexts/CollectionContext';
import { useOrganization } from '_/contexts/OrganizationContext';
import { useProject } from '_/contexts/ProjectContext';

export const useSourceUrl = (slug: string): string => {
  const { selectedOrgSlug: orgSlug } = useOrganization();
  const { selectedProjectSlug: projectSlug } = useProject();
  const { selectedCollectionSlug: collectionSlug } = useCollection();
  return `/orgs/${orgSlug}/projects/${projectSlug}/collections/${collectionSlug}/sources/${slug}`;
};
